import { Stack } from '@fluentui/react'
import { ArrowLeft20Filled } from "@fluentui/react-icons";
import { cardRadius, dashboardTheme, newLightTheme, unauthorisedPosition } from '../../styles/customStyles';
import { Button, Card, FluentProvider, Image, LargeTitle, Text, Tooltip } from '@fluentui/react-components'

export const Unauthorised = () => (
  <FluentProvider theme={newLightTheme}>
    <Card style={{ ...cardRadius, ...unauthorisedPosition }}>
      <Stack verticalAlign="center" horizontalAlign="center" tokens={{ childrenGap: 10 }}>
        <Image src="/Dashboard/image/signinLogo.svg" alt='Nanoheal Logo' />
        <LargeTitle> Unauthorized Access. </LargeTitle>
        <Text> You do not have access to this, Please contact Admin. </Text>
        <Text> OR </Text>
        <FluentProvider theme={dashboardTheme}>
          <Tooltip content="Click here to go back..." relationship="label" withArrow positioning="below">
            <Button appearance="primary" shape="circular" icon={<ArrowLeft20Filled />} iconPosition="before" onClick={() => window.history.back()}>
              Go back
            </Button>
          </Tooltip>
        </FluentProvider>
      </Stack>
    </Card>
  </FluentProvider>
);
